import { render, staticRenderFns } from "./footeritem.vue?vue&type=template&id=c8797990&scoped=true"
import script from "./footeritem.vue?vue&type=script&lang=js"
export * from "./footeritem.vue?vue&type=script&lang=js"
import style0 from "./footeritem.vue?vue&type=style&index=0&id=c8797990&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8797990",
  null
  
)

export default component.exports